(function (app) {

    app.run([
        "authService", "$transitions", function (authService, $transitions) {

            //TODO: change this to mean everything except the login/logout pages
            //currently everything falls under Home. but may not always be the case
            //TODO: include redirect info, like where the user was going so that after login they may continue 
            //TODO: or..instead of redirecting to login, have a modal come up and ask for auth?
            //that seems more like a popup warning on session timeout rather than waiting for the user
            //to change states so maybe this is fine
            $transitions.onBefore({ to: "Home.**" },
                function (transition) {
                    if (authService.isAuthenticated()) return undefined;
                    return transition.router.stateService.target("Login");
                });

            $transitions.onBefore({ to: "Login" },
                function (transition) {
                    if (!authService.isAuthenticated()) return undefined;
                    return transition.router.stateService.target("Home");
                });

            $transitions.onBefore({ to: "Register" },
                function (transition) {
                    if (!authService.isAuthenticated()) return undefined;
                    return transition.router.stateService.target("Home");
                });
            $transitions.onBefore({ to: "Invalid" },
                function (transition) {
                    if (!authService.isAuthenticated()) return undefined;
                    return transition.router.stateService.target("Home");
                });
        }
    ]);

    app.run([
        "permissionService", "$transitions", function (permissionService, $transitions) {
            $transitions.onEnter({},
                function (transition) {
                    var permissions = transition.$to().requiredPermissions;
                    if (!permissions) return undefined;
                    if (permissionService.hasAllPermissions(permissions)) return undefined;
                    return transition.router.stateService.target("Home");
                },
                { priority: 1 });
        }
    ]);

    //app.run(["$trace", function($trace) { $trace.enable("TRANSITION"); }]);

})(window.app);